import React from 'react';
import bannerDesktopImage from '@stack/assets/images/consignment/banner-desktop.png';
import bannerMobileImage from '@stack/assets/images/consignment/banner-mobile.png';

import { ConsignInner } from '../styles';

import { ConsignBannerProps } from './props';
import { BannerContainer, BannerContent, BannerImage } from './styles';

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const ConsignBanner: React.FC<ConsignBannerProps> = (props) => {
  const { webView } = props;

  // ======================= HOOKS

  // ======================= STATE

  // ======================= EFFECTS

  // ======================= VARIABLES

  // ======================= VIEWS
  return (
    <BannerContainer>
      {/*
        <picture> rather than two <Image>s: the desktop banner is 2.2MB and a `display: none`
        sibling is still fetched by the browser. This requests exactly one file per viewport.
      */}
      <picture>
        <source
          media="(min-width: 576px)"
          srcSet={bannerDesktopImage.src}
          width={2880}
          height={720}
        />
        <BannerImage
          src={bannerMobileImage.src}
          width={750}
          height={520}
          alt=""
        />
      </picture>

      <ConsignInner>
        <BannerContent $fullWidth={webView}>
          <h4>Malaysia First Used Car and EV Consignment Platform</h4>
          <p>
            This is the best place to sell your car at true market value.
            Instead of accepting low dealer trade-ins, we handle everything and
            connect your car directly to genuine buyers for the highest price.
          </p>
        </BannerContent>
      </ConsignInner>
    </BannerContainer>
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export * from './props';
export default ConsignBanner;
